import "./loader.css";

const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-inner"></div>
    </div>
  );
};

export default Loader;